import React from 'react';
import SectionHeader from './SectionHeader';
import ArticleCard from './ArticleCard';
import { Article, SectionData } from '../types/types';

interface TwoOneLayoutProps {
  articles: Article[];
  sectionDatas: SectionData;
}

const TwoOneLayout: React.FC<TwoOneLayoutProps> = ({ articles, sectionDatas }) => {
  const featuredArticle = articles[0];
  const otherArticles = articles.slice(1);
  const isExternal = sectionDatas.linkIcon === 'external';

  return (
    <div className="react-block__two-one-layout">
      {sectionDatas && (
        <SectionHeader
          title={sectionDatas.title}
          linkLabel={sectionDatas.sectionLinkText}
          url={sectionDatas.sectionUrl}
          hasPreIcon={sectionDatas.showIcon}
          isExternal={isExternal}
          iconUrl={sectionDatas.iconUrl}
          hasTitleLink={sectionDatas.hasTitleLink}
          hideHeader={sectionDatas.hideHeader}
        />
      )}
      <div className="react-block__two-one-layout-wrapper">
        <div className="react-block__two-one-layout-featured">
          <ArticleCard article={featuredArticle} cardType={'two-third'} />
        </div>
        <div className="react-block__two-one-layout-non-featured">
          {otherArticles.map((article, index) => (
            <ArticleCard key={index} article={article} cardType={'one-third'} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TwoOneLayout;
